export default __webpack_public_path__ + "static/media/Go_Work_new_logo.f315b55c.png";